<pbc-sorter [config]="DurchsuchenSorterConfig" [sorter]="durchsuchen.sorter$ | async" (sorterChange)="durchsuchen.sorter$.next($event)"></pbc-sorter>
